import _ from 'lodash'
import styled from 'styled-components'

import StarIcon from 'pared/images/Pared/star.svg'

interface IProps {
  numberOfStars: number
}

function Main({ numberOfStars }: IProps) {
  let stars = []

  for (let i = 0; i < numberOfStars; i++) {
    stars.push(
      <StarIconImgContainer key={i}>
        <img src={StarIcon} alt="Info" />
      </StarIconImgContainer>,
    )
  }

  return <>{stars}</>
}

const StarIconImgContainer = styled.div`
  margin-right: 5px;
  float: left;
`

export default Main
